"use strict";
exports.__esModule = true;
exports.resultsTableSorters = void 0;
var tslib_1 = require("tslib");
var Table_1 = require("@sportnet/ui/lib/Table");
var Tooltip_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Tooltip"));
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var utilities_1 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var ContentContext_1 = tslib_1.__importDefault(require("../../../common/ContentContext"));
var Header_1 = tslib_1.__importDefault(require("../../../view/components/Header"));
var utilities_2 = require("../MatchesList/utilities");
var StyledTr = styled_components_1["default"](Table_1.Tr)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  :hover > td {\n    background: inherit;\n  }\n"], ["\n  :hover > td {\n    background: inherit;\n  }\n"])));
var Condition = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ConditionItem = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  font-size: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  background: ", ";\n  color: white;\n"], ["\n  width: ", ";\n  height: ", ";\n  font-size: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  background: ",
    ";\n  color: white;\n"])), polished_1.rem(24), polished_1.rem(24), polished_1.rem(12), function (_a) {
    var theme = _a.theme, result = _a.result;
    if (result === 'W') {
        return theme.color.success;
    }
    else if (result === 'D') {
        return theme.color.warning;
    }
    else if (result === 'L') {
        return theme.color.danger;
    }
    return theme.color.primary;
});
var Title = styled_components_1["default"](Header_1["default"])(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  && {\n    > h2 {\n      font-size: ", ";\n      font-weight: bold;\n    }\n  }\n"], ["\n  && {\n    > h2 {\n      font-size: ", ";\n      font-weight: bold;\n    }\n  }\n"])), polished_1.rem(18));
exports.resultsTableSorters = {
    resignation: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        if (a.team.resignation && !b.team.resignation) {
            return 1;
        }
        else if (!a.team.resignation && b.team.resignation) {
            return -1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    points: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        if (a.stats.points > b.stats.points) {
            return -1;
        }
        else if (a.stats.points < b.stats.points) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    goalDifference: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        var aGoalsDifference = a.stats.goals.given - a.stats.goals.received;
        var bGoalsDifference = b.stats.goals.given - b.stats.goals.received;
        if (aGoalsDifference > bGoalsDifference) {
            return -1;
        }
        else if (aGoalsDifference < bGoalsDifference) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    goalsGiven: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        if (a.stats.goals.given > b.stats.goals.given) {
            return -1;
        }
        else if (a.stats.goals.given < b.stats.goals.given) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    wins: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        if (a.stats.matches.won > b.stats.matches.won) {
            return -1;
        }
        else if (a.stats.matches.won < b.stats.matches.won) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    draws: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        if (a.stats.matches.draw > b.stats.matches.draw) {
            return -1;
        }
        else if (a.stats.matches.draw < b.stats.matches.draw) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    awayWins: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        if (a.awayStats &&
            b.awayStats &&
            a.awayStats.matches.won > b.awayStats.matches.won) {
            return -1;
        }
        else if (a.awayStats &&
            b.awayStats &&
            a.awayStats.matches.won < b.awayStats.matches.won) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    awayDraws: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        if (a.awayStats &&
            b.awayStats &&
            a.awayStats.matches.draw > b.awayStats.matches.draw) {
            return -1;
        }
        else if (a.awayStats &&
            b.awayStats &&
            a.awayStats.matches.draw < b.awayStats.matches.draw) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    commonMatchesPoints: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        var commonMatches = (a.matches || []).filter(function (m) { return m.team._id === b.team._id; });
        var aWins = commonMatches.filter(function (match) { return match.result === 'W'; });
        var bWins = commonMatches.filter(function (match) { return match.result === 'L'; });
        var draws = commonMatches.filter(function (match) { return match.result === 'D'; });
        var aPoints = aWins.length * 3 + draws.length;
        var bPoints = bWins.length * 3 + draws.length;
        if (aPoints > bPoints) {
            return -1;
        }
        else if (aPoints < bPoints) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    commonMatchesGoalDifference: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        var commonMatches = (a.matches || []).filter(function (m) { return m.team._id === b.team._id; });
        var aGoals = 0;
        var bGoals = 0;
        commonMatches.forEach(function (match) {
            var _a = match.score.split(':'), firstScore = _a[0], secondScore = _a[1];
            if (match.homeaway === 'home') {
                aGoals = aGoals + Number(firstScore);
                bGoals = bGoals + Number(secondScore);
            }
            else {
                aGoals = aGoals + Number(secondScore);
                bGoals = bGoals + Number(firstScore);
            }
        });
        if (commonMatches.length > 1 && aGoals > bGoals) {
            return -1;
        }
        else if (commonMatches.length > 1 && aGoals < bGoals) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    },
    commonMatchesAwayGoals: function (a, b, nextSorters) {
        if (nextSorters === void 0) { nextSorters = []; }
        var aAwayGoals = 0;
        var bAwayGoals = 0;
        var commonMatches = (a.matches || []).filter(function (m) { return m.team._id === b.team._id; });
        commonMatches.forEach(function (match) {
            var _a = match.score.split(':'), secondScore = _a[1];
            if (match.homeaway === 'home') {
                bAwayGoals = bAwayGoals + Number(secondScore);
            }
            else {
                aAwayGoals = aAwayGoals + Number(secondScore);
            }
        });
        if (aAwayGoals > bAwayGoals) {
            return -1;
        }
        else if (aAwayGoals < bAwayGoals) {
            return 1;
        }
        if ((nextSorters || []).length) {
            var nextSorter = nextSorters[0], restSorters = nextSorters.slice(1);
            return nextSorter(a, b, restSorters);
        }
        return 0;
    }
};
// export const sortersByCompetitionLevel: {
//   [key: string]: IResultsTableSorter[];
// } = {
//   '1': [
//     resultsTableSorters.resignation,
//     resultsTableSorters.points,
//     resultsTableSorters.commonMatchesPoints,
//     resultsTableSorters.commonMatchesGoalDifference,
//     resultsTableSorters.commonMatchesAwayGoals,
//   ],
//   '2': [
//     resultsTableSorters.resignation,
//     resultsTableSorters.points,
//     resultsTableSorters.commonMatchesPoints,
//     resultsTableSorters.commonMatchesGoalDifference,
//     resultsTableSorters.commonMatchesAwayGoals,
//   ],
//   default: [
//     resultsTableSorters.resignation,
//     resultsTableSorters.points,
//     resultsTableSorters.goalDifference,
//     resultsTableSorters.goalsGiven,
//     resultsTableSorters.wins,
//     resultsTableSorters.awayWins,
//     resultsTableSorters.draws,
//     resultsTableSorters.awayDraws,
//   ],
// };
var commonSorters = [
    exports.resultsTableSorters.resignation,
    exports.resultsTableSorters.points,
    exports.resultsTableSorters.commonMatchesPoints,
    exports.resultsTableSorters.commonMatchesGoalDifference,
    exports.resultsTableSorters.goalDifference,
    exports.resultsTableSorters.goalsGiven,
    exports.resultsTableSorters.wins,
    exports.resultsTableSorters.awayWins,
    exports.resultsTableSorters.draws,
    exports.resultsTableSorters.awayDraws,
];
var WidgetResultsTable = function (_a) {
    var data = _a.data, renderEmpty = _a.renderEmpty;
    var context = React.useContext(ContentContext_1["default"]);
    var _b = React.useState([]), highlightedTeams = _b[0], setHighlightedTeams = _b[1];
    var getResultLabel = function (result) {
        switch (result) {
            case 'W':
                return 'V';
            case 'D':
                return 'R';
            case 'L':
                return 'P';
            default:
                return '';
        }
    };
    var getTeamCondition = function (result) {
        var lastFive = tslib_1.__spreadArrays((result.matches || [])).slice(0, 5);
        return lastFive.map(function (m) {
            var matchLabel = (m.homeaway === 'home' ? result.team && result.team.name : m.team.name) + " - " + (m.homeaway === 'away' ? result.team && result.team.name : m.team.name);
            return (React.createElement(Tooltip_1["default"], { key: matchLabel, content: React.createElement("div", null,
                    React.createElement("b", null, m.score),
                    " (",
                    matchLabel,
                    ")") },
                React.createElement("div", { style: { padding: "0 " + polished_1.rem(2) }, onMouseEnter: function () {
                        if (result.team) {
                            setHighlightedTeams([result.team._id, m.team._id]);
                        }
                    }, onMouseLeave: function () {
                        setHighlightedTeams([]);
                    } },
                    React.createElement(ConditionItem, { result: m.result }, getResultLabel(m.result)))));
        });
    };
    var sortResults = function (results) {
        var currentSorter = commonSorters[0], sorters = commonSorters.slice(1);
        return results.sort(function (a, b) { return currentSorter(a, b, sorters); });
    };
    if ((!data.competitionId || !data.partId) && renderEmpty) {
        return React.createElement(React.Fragment, null, renderEmpty('resultsTable'));
    }
    var renderTableHeader = function () {
        if (data.data && data.data.rules.sport_sector === 'beachfutbal') {
            return (React.createElement(Table_1.Tr, null,
                React.createElement(Table_1.Th, { width: 30 }),
                React.createElement(Table_1.Th, null, "Dru\u017Estvo"),
                React.createElement(Table_1.Th, { width: 30 }, "Z"),
                React.createElement(Table_1.Th, { width: 30 }, "V"),
                React.createElement(Table_1.Th, { width: 30 }, "Vp"),
                React.createElement(Table_1.Th, { width: 30 }, "Vpen"),
                React.createElement(Table_1.Th, { width: 60 }, "Sk\u00F3re"),
                React.createElement(Table_1.Th, { width: 30 }, "B"),
                React.createElement(Table_1.Th, { width: 160 }, "Forma")));
        }
        return (React.createElement(Table_1.Tr, null,
            React.createElement(Table_1.Th, { width: 30 }),
            React.createElement(Table_1.Th, null, "Dru\u017Estvo"),
            React.createElement(Table_1.Th, { width: 30 }, "Z"),
            React.createElement(Table_1.Th, { width: 30 }, "V"),
            React.createElement(Table_1.Th, { width: 30 }, "R"),
            React.createElement(Table_1.Th, { width: 30 }, "P"),
            React.createElement(Table_1.Th, { width: 60 }, "Sk\u00F3re"),
            React.createElement(Table_1.Th, { width: 30 }, "B"),
            React.createElement(Table_1.Th, { width: 160 }, "Forma")));
    };
    var renderTableContent = function (result, idx) {
        var teamName = utilities_1.getProp(context, ['helpers', 'getTeamName'], utilities_2.getTeamName)(data.appSpace, result.team);
        var content = (React.createElement(React.Fragment, null,
            React.createElement(Table_1.Td, null, idx + 1),
            React.createElement(Table_1.Td, null, teamName),
            React.createElement(Table_1.Td, null, result.stats.matches.played),
            React.createElement(Table_1.Td, null, result.stats.matches.won),
            React.createElement(Table_1.Td, null, result.stats.matches.draw),
            React.createElement(Table_1.Td, null, result.stats.matches.lost),
            React.createElement(Table_1.Td, null,
                result.stats.goals.given,
                ":",
                result.stats.goals.received),
            React.createElement(Table_1.Td, null, result.stats.points),
            React.createElement(Table_1.Td, null,
                React.createElement(Condition, null, getTeamCondition(result)))));
        if (data.data && data.data.rules.sport_sector === 'beachfutbal') {
            content = (React.createElement(React.Fragment, null,
                React.createElement(Table_1.Td, null, idx + 1),
                React.createElement(Table_1.Td, null, teamName),
                React.createElement(Table_1.Td, null, result.stats.matches.played),
                React.createElement(Table_1.Td, null, result.stats.matches.wonNT || 0),
                React.createElement(Table_1.Td, null, result.stats.matches.wonET || 0),
                React.createElement(Table_1.Td, null, result.stats.matches.wonP || 0),
                React.createElement(Table_1.Td, null,
                    result.stats.goals.given,
                    ":",
                    result.stats.goals.received),
                React.createElement(Table_1.Td, null, result.stats.points),
                React.createElement(Table_1.Td, null,
                    React.createElement(Condition, null, getTeamCondition(result)))));
        }
        return (React.createElement(StyledTr, { key: result.team._id, highlighted: result.team && highlightedTeams.includes(String(result.team._id)) }, content));
    };
    return (React.createElement(React.Fragment, null,
        !!data.title && React.createElement(Title, null, data.title),
        React.createElement(Table_1.Table, null,
            React.createElement(Table_1.Thead, null, renderTableHeader()),
            React.createElement(Table_1.Tbody, null, data.data && sortResults(data.data.results).map(renderTableContent)))));
};
exports["default"] = WidgetResultsTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
